"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var attributes_1 = require("../../constants/attributes");
var isKeyboardMode = function () {
    if (typeof document === "undefined")
        return;
    return !!document.querySelector("[".concat(attributes_1.keyboardMode, "]"));
};
exports.default = isKeyboardMode;
